import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { SearchBar } from '../../../components/Common/SearchBar';
import Table1 from "../../../components/Common/TableContainer";
import { getUsers } from '../../../store/catalogs/Users/actions';

import { BaseCustomButton, BaseCustomModal, GradientDecorationLine } from '../../../shared';

export const AssignUserModal = ({ props, setShowModal, showModal, modalRespInfo }) => {
    const [rowUserIds, setRowUserIds] = useState([]);
    const [check, setCheck] = useState();
    const [checkID, setCheckID] = useState();

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getUsers(`?limit=20&page=0&userType=Operativo&recordStatus=enable`)); // TODO: IMPORTANTE, falta colocar le filtro por el record status de ACTIVO y también "Laboratory type"????????????
    }, [dispatch])

    const { users, loading, total, currentPage, } = useSelector(state => ({
        users: state.usersReducer.users,
        loading: state.usersReducer.loading,
        total: state.usersReducer.total,
        currentPage: state.usersReducer.currentPage,
    }), shallowEqual);

    const [searchData, setSearchData] = useState('');

    useEffect(() => {
        dispatch(getUsers(`?limit=20&page=0&userType=Operativo&recordStatus=enable&search=${searchData}`));
        setRowUserIds([]);
    }, [dispatch, searchData])

    //Modal de Registro
    const { className } = props;

    const toggle = () => {
        setShowModal(false);
    }

    const onClosed = () => {
        setRowUserIds([]);
        setShowModal(false);
    }

    useEffect(() => {
        if (checkID !== undefined) {
            setRowUserIds(prev => prev.map((element) => { //Update the status of "checkStatus" of all values "UUID" that match
                if (element.id === checkID) {
                    return {
                        ...element,
                        checkStatus: check,
                    }
                } else {
                    return element;
                }
            }));
        }
    }, [check, checkID]);

    const onSelected = (value, checkStatus) => { //Value alredy is the "id" selected; checkStatus is true or false that is the current check status

        setRowUserIds(rowUserIds => [ //always add to the array the id and the selected status
            ...rowUserIds,
            {
                ...value, // value: 'UUID'
                checkStatus: checkStatus,
            }
        ]);

        setCheck(checkStatus);
        setCheckID(value.id)
    }

    const submit = () => {

        let filteredArray;
        let filteredArrayAux;
        let deletedRepeatedElementsArray;
        let deletedRepeatedElementsArrayAux;

        filteredArray = rowUserIds.filter(rowTestId => rowTestId.checkStatus === true); // TODO: Ya lo filtramos, ahora tenemos que  eliminar los elementos repetidos.

        filteredArrayAux = filteredArray.map((item) => JSON.stringify(item));

        deletedRepeatedElementsArray = filteredArrayAux.filter((item, index) => { //delete repeated elements from an array
            return filteredArrayAux.indexOf(item) === index;
        })

        deletedRepeatedElementsArrayAux = deletedRepeatedElementsArray.map((item) => JSON.parse(item));

        if (deletedRepeatedElementsArrayAux.length > 0) {
            modalRespInfo(deletedRepeatedElementsArrayAux); // TODO: Aqui le debo de mandar ya solo el array final filtrado y todo
            setShowModal(false);
        }
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'Nombre de usuario',
                width: '25%',
                Cell: ({ row }) => (
                    <div className='text-left'>{row.original.name} {row.original.surname}</div>
                ),
            },
            {
                Header: 'Tipo de Laboratorio',
                width: '20%',
                Cell: ({ row }) => (
                    <div className='text-left'>{row.original.laboratoryType?.name ?? '-'}</div>
                ),
            },
            {
                Header: 'Rol de Usuario',
                accessor: 'role',
                width: '25%',
            },
            {
                Header: 'Sede',
                width: '20%',
                Cell: ({ row }) => (
                    <div className='text-left'>{row.original.location?.name ?? '-'}</div>
                ),
            },
            {
                width: '5%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-center">
                        <input className="form-check-input rounded-pill p-3" type="checkbox" id="checkboxNoLabel" value="" aria-label="..." onClick={(e) => { onSelected(row.original, e.target.checked) }}></input>
                    </div>
                ),
            },
        ],
        []
    )

    const getPagination = (params) => {
        dispatch(getUsers(`${params}&userType=Operativo&recordStatus=enable&search=${searchData}`));
    }

    const title = (
        <div className='d-flex ms-3 p-0'>
            <label className='m-0 p-0'><h4 className='text-primary m-0 ps-4'>Asignar Usuarios</h4></label>
        </div>
    );

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color='success'
                className='rounded-3 me-2'
                onClick={submit}
                label='Guardar'
                outline={true}
                icon="mdi mdi-content-save me-1"
            />
            <BaseCustomButton
                color='danger'
                className='rounded-3 me-3'
                onClick={toggle}
                label='Cancelar'
                outline={true}
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );

    return (
        <>
            <BaseCustomModal
                title={title} 
                isModalOpen={showModal}
                handleCancel={toggle}
                onClosed={onClosed}
                width="80%"
                className={className}
                footer={buttons} 
            >
                <GradientDecorationLine />

                <div className="px-4 mx-3">
                    <SearchBar setSearchData={setSearchData} />

                    <div className="px-0 py-2">
                        <Table1
                            currentPage={currentPage}
                            getPagination={getPagination}
                            total={total}
                            loading={loading}
                            isAddTableBorderStrap
                            columns={columns}
                            data={users}
                        />
                    </div>
                </div>

                <GradientDecorationLine />
            </BaseCustomModal>
        </>
    )
}
